import { Navigate, useSearchParams } from "react-router-dom";

import { AliquotasInternas, MatrizIcms } from "@/components/operacoes/MatrizIcms";
import { IndicesFiscais } from "@/components/operacoes/IndicesFiscais";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function BaseTaxPage() {
  // A sub-aba vai na URL.
  const [params, setParams] = useSearchParams();
  const aba = params.get("aba") ?? "matriz";

  // O repositório virou item próprio do menu; links antigos seguem para ele.
  if (aba === "repositorio") return <Navigate to="/repositorio" replace />;

  return (
    <div className="space-y-5">
      <Tabs value={aba} onValueChange={(valor) => setParams({ aba: valor }, { replace: true })}>
        <TabsList>
          <TabsTrigger value="matriz">Matriz origem × destino</TabsTrigger>
          <TabsTrigger value="indices">Índices fiscais</TabsTrigger>
          <TabsTrigger value="internas">Alíquotas internas</TabsTrigger>
        </TabsList>

        <TabsContent value="matriz">
          <MatrizIcms />
        </TabsContent>
        <TabsContent value="indices">
          <IndicesFiscais />
        </TabsContent>
        <TabsContent value="internas">
          <AliquotasInternas />
        </TabsContent>
      </Tabs>
    </div>
  );
}
